export var DataType;
(function (DataType) {
    DataType["PATENT"] = "patent";
    DataType["PAPER"] = "paper";
    DataType["BIO"] = "bio";
    DataType["DRUG"] = "drug";
    DataType["CLINICAL"] = "clinical";
    DataType["MARKET"] = "market";
    DataType["INVESTMENT"] = "investment";
    DataType["MERGER"] = "merger";
    DataType["CLINICAL_RESULT"] = "clinical_result";
})(DataType || (DataType = {}));
